import accessPolicy from './allowedGoogleAccounts.json'

export const ACCESS_DENIED = 'This Google account is not allowed to access SPCC.'

export const isAllowedFirebaseUser = user => !!user?.uid
  && user.emailVerified === true
  && accessPolicy.allowedGoogleEmails.includes(user.email?.toLowerCase())
  && user.providerData?.some(provider => provider.providerId === 'google.com') === true

export const signInErrorMessage = error => ['auth/admin-restricted-operation', 'auth/user-disabled', 'auth/access-denied'].includes(error?.code)
  ? ACCESS_DENIED : error?.message || 'Could not sign in. Please try again.'
